// extracted by mini-css-extract-plugin
module.exports = {"bold":"BackgroundAndIdentityDetails_bold__24O5m","subHeadingH3":"BackgroundAndIdentityDetails_subHeadingH3__EyOsZ","subInfo":"BackgroundAndIdentityDetails_subInfo__3blIL"};